const BrowserRegEx =
  /(MSIE|Trident|(?!Gecko.+)Firefox|(?!AppleWebKit.+Chrome.+)Safari(?!.+Edg)|(?!AppleWebKit.+)Chrome(?!.+Edg)|(?!AppleWebKit.+Chrome.+Safari.+)Edg|AppleWebKit(?!.+Chrome|.+Safari)|Gecko(?!.+Firefox))(?: |\/)([\d\.apre]+)/;
const OSRegEx = /\(.*?\)/;

function track(appName) {
  // if (window.location.href.includes('localhost')) return;
  const timestamp = localStorage.getItem(appName);
  if (!timestamp || getTimeDifferenceinHours(timestamp) > 1) {
    const useragent = window.navigator.userAgent;
    const browser = useragent.match(BrowserRegEx)[0];
    const os = useragent.match(OSRegEx)[0];
    const response = fetch('https://app.rk-rose-krieger.com/api/stats/stat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ App: appName, UserAgent: useragent, Browser: browser, OS: os }),
    });
  } else {
    // console.log('Kein Aufruf');
  }
  localStorage.setItem(appName, Date.now());
}

function getTimeDifferenceinHours(timestamp) {
  if (!timestamp) return 0;
  const diff = (Date.now() - timestamp) / 1000 / 60 / 60;
  return diff;
}

export default track;
